import React, { useCallback, useState } from "react";
import { Nav, Navbar } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import classNames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import IconButton from "../common/IconButton";
import Logo from "../common/Logo";
import {
  faBars,
  faKey,
  faRightFromBracket,
} from "@fortawesome/free-solid-svg-icons";
import Cookies from "js-cookie";
import ChangePasswordModal from "../Components/Modals/ChangePasswordModal";

type Props = {
  className?: string;
  showSidebar?: VoidFunction;
};

export default function AppNavbar({ className, showSidebar }: Props) {
  const location = useLocation();
  const [showChangePassword, setShowChangePassword] = useState(false);

  const handleSidebarToggle = (evt: React.MouseEvent) => {
    evt.stopPropagation();
    showSidebar?.();
  };

  const handleLogout = useCallback(() => {
    Cookies.remove(window.__env.AUTH_TOKEN_NAME || "get-move-token");
    Cookies.remove(window.__env.AUTH_USER_NAME || "get-move-user");
    window.location.reload();
  }, []);

  return (
    <Navbar
      className={classNames(
        "app-navbar d-flex flex-row align-items-center shadow-sm border-bottom",
        className
      )}
    >
      {![
        "/privacy-policy",
        "/conferma-registrazione",
        "/termini-e-condizioni-d-uso",
        "/domande-frequenti",
        "/contattaci",
      ].includes(location.pathname) &&
        !location.pathname.startsWith("/Share/") && (
          <IconButton className="mx-2 ms-3" onClick={handleSidebarToggle}>
            <FontAwesomeIcon size="xl" className="text-white" icon={faBars} />
          </IconButton>
        )}

      <Link to="/">
        <Navbar.Brand>
          <Logo height={75} className="d-inline-block align-top px-md-3" />
        </Navbar.Brand>
      </Link>

      <Nav className="flex-row align-items-center ms-auto">
        {![
          "/privacy-policy",
          "/conferma-registrazione",
          "/termini-e-condizioni-d-uso",
          "/domande-frequenti",
          "/contattaci",
        ].includes(location.pathname) &&
          !location.pathname.startsWith("/Share/") && (
            <>
              <IconButton
                title="Cambia password"
                onClick={() => setShowChangePassword(true)}
              >
                <FontAwesomeIcon
                  color="#FFF"
                  size="lg"
                  className="me-3"
                  icon={faKey}
                />
              </IconButton>
              <IconButton title="Esci" onClick={handleLogout}>
                <FontAwesomeIcon
                  color="#FFF"
                  size="lg"
                  className="me-3"
                  icon={faRightFromBracket}
                />
              </IconButton>
            </>
          )}
      </Nav>
      <ChangePasswordModal
        show={showChangePassword}
        onClose={() => setShowChangePassword(false)}
      />
    </Navbar>
  );
}
